import React, { FormEvent } from 'react'
import { useForm, Link } from '@inertiajs/react'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { AuthLayout } from '@/components/layouts/AuthLayout'

interface RegisterProps {
  minimum_password_length: number
}

export default function Register({ minimum_password_length }: RegisterProps) {
  const { data, setData, post, processing, errors } = useForm({
    agent: {
      username: '',
      password: '',
      password_confirmation: '',
    },
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post('/agents')
  }

  return (
    <AuthLayout title="Create account">
      <Box component="form" onSubmit={handleSubmit} noValidate>
        <TextField
          label="Username"
          fullWidth
          autoFocus
          autoComplete="username"
          value={data.agent.username}
          onChange={e => setData('agent', { ...data.agent, username: e.target.value })}
          error={'agent.username' in errors}
          helperText={(errors as Record<string, string>)['agent.username']}
          sx={{ mb: 2.5 }}
        />
        <TextField
          label="Password"
          type="password"
          fullWidth
          autoComplete="new-password"
          value={data.agent.password}
          onChange={e => setData('agent', { ...data.agent, password: e.target.value })}
          error={'agent.password' in errors}
          helperText={(errors as Record<string, string>)['agent.password'] || `${minimum_password_length} characters minimum`}
          sx={{ mb: 2.5 }}
        />
        <TextField
          label="Password confirmation"
          type="password"
          fullWidth
          autoComplete="new-password"
          value={data.agent.password_confirmation}
          onChange={e => setData('agent', { ...data.agent, password_confirmation: e.target.value })}
          error={'agent.password_confirmation' in errors}
          helperText={(errors as Record<string, string>)['agent.password_confirmation']}
          sx={{ mb: 3 }}
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          size="large"
          disabled={processing}
          sx={{ mb: 2 }}
        >
          Create account
        </Button>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Already have an account?{' '}
            <Link href="/agents/sign_in" style={{ color: '#1a1a1a' }}>Sign in</Link>
          </Typography>
        </Box>
      </Box>
    </AuthLayout>
  )
}
